import { configureStore } from '@reduxjs/toolkit'
import collectionsSlicers from './slicers'
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'authtoken',
  initialState: {},
  reducers: {
    setLoginUser: (state, action) => {
      state.authToken = action.payload.authToken;
      state.role = action.payload.role;
      state.userName = action.payload.userName;
      state.init_password = action.payload.init_password;
    },
    deleteLoginUser: (state) => {
      state.authToken = '';
      state.role = '';
      state.userName = '';
      state.init_password =false;
    }
  },
});

export const { setLoginUser, deleteLoginUser} = authSlice.actions;


export const store = configureStore({
    devTools : true,
    reducer: {
        collections : collectionsSlicers,       
        authtoken: authSlice.reducer   
    },
})